import { render, staticRenderFns } from "./DialogInfo.vue?vue&type=template&id=667de5c6&"
import script from "./DialogInfo.vue?vue&type=script&lang=js&"
export * from "./DialogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports